export const loadRazorpay = () =>
  new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve();
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = resolve;
    s.onerror = () => reject(new Error("Could not load payment gateway"));
    document.body.appendChild(s);
  });

export const openRazorpayCheckout = ({ data, prefill, description, onSuccess, onDismiss }) => {
  const rzp = new window.Razorpay({
    key: data.razorpay_key_id,
    amount: data.amount,
    currency: data.currency || "INR",
    name: "The Birth Life",
    description,
    order_id: data.razorpay_order_id,
    prefill,
    theme: { color: "#6B2737" },
    handler: onSuccess,
    modal: { ondismiss: onDismiss || (() => {}) },
  });
  rzp.open();
};
